<template>
    <svg
        class="product-lines-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        stroke="var(--palette-gray-100)"
        :style="{ color: 'var(--palette-gray-100)' }"
        fill="none">
        <g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2.5">
            <path
                d="M11.75 20.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM19.25 20.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM4.25 20.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.75 13a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM19.25 13a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM4.25 13a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.75 5.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM19.25 5.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM4.25 5.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" />
        </g>
    </svg>
</template>
<script>
export default {
    name: 'ProductLinesIcon',
};
</script>
